var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",staticStyle:{"overflow":"hidden"}},[_c('home-header'),_c('home-bio'),_c('portfolio'),_c('contact'),_c('div',{staticClass:"my-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }